import { useCallback, useMemo, useState } from 'react';

import { useIntl } from 'react-intl';

import { DASHBOARDS_FORMS } from '../../../screens/EventsDashboard/constants';

const useMetricsDrawer = ({
  metricsComponenteSelected,
  componentConfig,
  onClose,
  setMetricsComponenteSelected,
}) => {
  const [search, setSearch] = useState('');
  const intl = useIntl();

  const { formRefsMap, currentElementSelectedRef } = componentConfig;
  const currentElementSelected = currentElementSelectedRef.current;

  const registerFormRef = useCallback((type) => (element) => {
    formRefsMap.current[type] = element;
  }, [formRefsMap]);

  const isEditing = useMemo(() => {
    if (!metricsComponenteSelected) return false;
    const selectedElement = currentElementSelected[metricsComponenteSelected];
    return metricsComponenteSelected === DASHBOARDS_FORMS.EVENT_TABLE
      ? !!selectedElement
      : !!selectedElement?.id;
  }, [metricsComponenteSelected, currentElementSelected]);

  const submitAction = useCallback(() => {
    if (metricsComponenteSelected && formRefsMap.current[metricsComponenteSelected]) {
      formRefsMap.current[metricsComponenteSelected]?.submit?.();
    }
  }, [metricsComponenteSelected, formRefsMap]);

  const clearAction = useCallback(() => {
    if (metricsComponenteSelected && formRefsMap.current[metricsComponenteSelected]) {
      formRefsMap.current[metricsComponenteSelected]?.handleClear?.();
    }
    setSearch('');
  }, [metricsComponenteSelected, formRefsMap]);

  const onBackAction = useCallback(() => {
    if (isEditing) {
      onClose();
    } else if (!isEditing && metricsComponenteSelected) {
      setMetricsComponenteSelected(null);
    } else {
      onClose();
    }
  }, [isEditing, metricsComponenteSelected, onClose, setMetricsComponenteSelected]);

  const buttonItems = useMemo(() => [
    {
      iconName: 'cleaning_services',
      action: clearAction,
      disabled: !metricsComponenteSelected,
      hidden: !metricsComponenteSelected || isEditing,
      tooltipText: intl.formatMessage({ id: 'button.clear' }),
      tooltipPosition: 'left',
      type: 'secondary',
    },
    {
      action: submitAction,
      iconName: 'save_as',
      disabled: !metricsComponenteSelected,
      hidden: !metricsComponenteSelected,
      tooltipText: intl.formatMessage({ id: 'button.save' }),
      tooltipPosition: 'left',
    },
  ], [clearAction, submitAction, metricsComponenteSelected, isEditing, intl]);

  const handleSearchChange = useCallback((e) => {
    setSearch(e.target.value);
  }, []);

  return {
    search,
    setSearch,
    isEditing,
    onBackAction,
    buttonItems,
    handleSearchChange,
    currentElementSelected,
    registerFormRef,
  };
};

export default useMetricsDrawer;
